import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { PaymentsFrequency } from '../../classes/enums';
import { MortgageService } from '../../services/mortgage.service';
import { MortageRateCategory } from '../../classes/mortgage-rate';
import { SelectOption } from '../../components/forms/select/select.component';
import { FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';

@Component({
  selector: 'app-mortgage-calculator',
  templateUrl: './mortgage-calculator.component.html',
  styleUrls: ['./mortgage-calculator.component.scss'],
})
export class MortgageCalculatorComponent implements OnInit, OnChanges {
  @Input() listingPrice: number = 0;
  // Makes the event emitter async
  @Output() onInitialRateSelected: EventEmitter<number> = new EventEmitter(true);
  @Output() onMortgagePaymentChange: EventEmitter<string> = new EventEmitter();


  showMoreSection: boolean = false;
  showCustomRate: boolean = false;
  rates: MortageRateCategory[] = [];
  mortgagePaymentAmount: string = '$0.00';
  paymentFrequencyText: string;
  mortgageForm: FormGroup;

  _hasFinishedRetrievingRates: boolean = false;
  _minimumDefaultDownPayment: number = 0.1;

  // TODO: is there a nice way to do this
  frequencyOptions: SelectOption[] = [
    {
      text: 'Weekly',
      value: PaymentsFrequency.Weekly
    } as SelectOption,
    {
      text: 'Rapid Weekly',
      value: PaymentsFrequency.RapidWeekly
    } as SelectOption,
    {
      text: 'Bi-Weekly',
      value: PaymentsFrequency.BiWeekly
    } as SelectOption,
    {
      text: 'Rapid Bi-Weekly',
      value: PaymentsFrequency.RapidBiWeekly
    } as SelectOption,
    {
      text: 'Monthly',
      value: PaymentsFrequency.Monthly
    } as SelectOption,
  ];
  rateOptions: SelectOption[] = [];

  constructor(private _mortgageService: MortgageService, private _formBuilder: FormBuilder) {
    this.mortgageForm = this._formBuilder.group({
      mortgageAmount: ['0', Validators.required],
      mortgageRate: 0,
      paymentFrequency: [5, Validators.required],
      amortizationPeriod: [25, Validators.required],
      customRate: null
    });
  }

  ngOnInit() {
    // TODO: filter list down to only right rates
    this._mortgageService.getRates().then((s: MortageRateCategory[]) => {
      this.rates = s;
      this.rates.forEach((rate) => rate.getRates().forEach((r) => {
        const text = `${r.name} ${r.rate}`;
        const rateValue = parseFloat(r.rate.replace('%', '')) / 100;
        this.rateOptions.push(new SelectOption(text, rateValue))
      }));
      this.mortgageForm.get('mortgageRate').setValue(this.rateOptions[0].value, {onlySelf: true});

      this.onInitialRateSelected.emit(this.rateOptions[0].value);
      this._hasFinishedRetrievingRates = true;
      this._calculateMortgage();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.mortgageForm.get('paymentFrequency').setValue(this.frequencyOptions[4].value, {onlySelf: true});
    this.mortgageForm.get('mortgageAmount').setValue(
      this.listingPrice ? this.listingPrice - Math.round(this.listingPrice * this._minimumDefaultDownPayment) : 0
      , {onlySelf: true});
    this._calculateMortgage();
  }

  onSubmit() {
    this._calculateMortgage();
  }

  toggleCustomRate() {
    this.showCustomRate = !this.showCustomRate;

    // Toggle the required validator for the custom rate
    if (this.showCustomRate) this.mortgageForm.controls.customRate.setValidators(Validators.required);
    else this.mortgageForm.controls.customRate.clearValidators();
    this.mortgageForm.controls.customRate.updateValueAndValidity();
  }


  private _calculateMortgage() {

    if (!this._hasFinishedRetrievingRates) {
      // console.log('havent finished retrieving data');
      return;
    }

    const controls = this.mortgageForm.controls;
    const rateToUse = this.showCustomRate ? controls.customRate.value / 100 : controls.mortgageRate.value;
    // this.mortgageForm.get('mortgageRate').setValue(this.rateOptions[0].value, {onlySelf: true});
    this.mortgagePaymentAmount = '$' + this._mortgageService.calculateMortgagePayment(controls.mortgageAmount.value, rateToUse, controls.paymentFrequency.value, controls.amortizationPeriod.value).toFixed(2);
    this.paymentFrequencyText = this._getPaymentFrequencyText(controls.paymentFrequency.value);
    this.onMortgagePaymentChange.emit(this.mortgagePaymentAmount);
  }

  private _getPaymentFrequencyText(frequency: PaymentsFrequency) {
    switch (frequency) {
      case PaymentsFrequency.Weekly: return 'Weekly';
      case PaymentsFrequency.BiWeekly: return 'Bi-Weekly';
      case PaymentsFrequency.Monthly: return 'Monthly';
      case PaymentsFrequency.RapidWeekly: return 'Rapid Weekly';
      case PaymentsFrequency.RapidBiWeekly: return 'Rapid Bi-Weekly';
      default: return '';
    };
  }

}
